export default __webpack_public_path__ + "static/media/mouseRightClick.fadfb575.svg";